var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forca"},[_c('img',{attrs:{"src":("https://raw.githubusercontent.com/william-costa/wdev-hangman-game-resources/master/images/hangman/" + _vm.erros + ".svg\n")}})])}
var staticRenderFns = []

export { render, staticRenderFns }